import moment, { Moment } from "moment"

export const getFormattedDate = (date: Moment): string => {
    return (moment(date)).format()
}

export const getYesterday = (): Date => {
    return moment().startOf("day").toDate()
}

export const getLastMonth = (): Date => {
    return moment().subtract(30, "days").toDate()
}


// WEBPACK FOOTER //
// ./src/utils/date/utils.ts